import { useState } from "react";
import { Link } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { CiMenuFries } from "react-icons/ci";
import logo from "../assets/logo.png";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 pt-4">
        {/* NAV BAR */}
        <div
          className="bg-gradient-to-r from-sky-500 via-sky-600 to-indigo-600 
                        rounded-3xl shadow-2xl px-5 md:px-10 py-4"
        >
          <div className="flex items-center justify-between relative">
            {/* LOGO */}
            <Link to="/">
            <img
              src={logo}
              alt="PGiyan Reunion"
              className="w-16 md:w-24 object-contain drop-shadow-lg"
            /></Link>
            {/* CENTER TITLE (DESKTOP PERFECT CENTER) */}
            <div className="hidden md:block absolute left-1/2 -translate-x-1/2 text-white text-center">
              <h1 className="text-3xl lg:text-4xl font-extrabold tracking-wide drop-shadow-md">
                PGiyan Reunion 2026
              </h1>
              <p className="text-sm opacity-90 tracking-wide">
                Celebrating Togetherness & Memories
              </p>
            </div>
            {/* DESKTOP MENU */}
            <nav className="hidden md:flex items-center gap-8 text-white font-medium">
              <Link className="hover:text-sky-200 transition" to="/">
                Home
              </Link>
              <Link className="hover:text-sky-200 transition" to="/buy-ticket">
                Buy Ticket
              </Link>
            </nav>
            {/* MOBILE BUTTON */}
            <button
              className="md:hidden text-white"
              onClick={() => setOpen(!open)}
            >
              {open ? <IoClose size={30} /> : <CiMenuFries size={30} />}
            </button>
          </div>
          {/* MOBILE TITLE */}
          <div className="md:hidden text-center text-white mt-3 space-y-1">
            <h1 className="text-xl font-extrabold tracking-wide">
              PGiyan Reunion 2026
            </h1>
            <p className="text-xs opacity-90">
              Celebrating Togetherness & Memories
            </p>
          </div>
        </div>
        {/* MOBILE MENU */}
        {open && (
          <div
            className="mt-4 bg-gradient-to-br from-sky-500 to-indigo-600 
                          rounded-3xl shadow-2xl p-6 flex flex-col 
                          gap-4 text-white font-medium animate-fadeIn"
          >
            <Link
              onClick={() => setOpen(false)}
              to="/"
              className="hover:text-sky-200"
            >
              Home
            </Link>
            <Link
              onClick={() => setOpen(false)}
              to="/buy-ticket"
              className="hover:text-sky-200"
            >
              Buy Ticket
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
